import api from './client'

export async function fetchProducts() {
  // 后台需拉全量商品用于编辑；接口默认 pageSize=10 会导致列表/刷新数据不全、随心订天数看似未保存
  return api.get('/products', { params: { page: 1, pageSize: 500 } })
}

export async function createProduct(payload) {
  return api.post('/products', payload)
}

export async function updateProduct(id, payload) {
  return api.put(`/products/${id}`, payload)
}

export async function deleteProductApi(id) {
  return api.delete(`/products/${id}`)
}

